import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { Grid, Box } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { PageHeader } from '../../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate } from "../../../Common";
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { TappingCheckListReportSchema } from "../TappingCheckListReportSchema";
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import CreatePdf from './createPdf';
import ReactToPrint from "react-to-print";
import '../../../Common/Table/table.css';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import divisionService from '../../../Devision/services';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Card from '@material-ui/core/Card';
import _ from 'lodash';

const screenCode = 'TAPPINGCHECKLISTREPORT'

export function TappingCheckListReport() {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [division, setDivision] = useState([]);
    const [jobs, setJobs] = useState();
    const [collectionCategory, setCollectionCategory] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [searchData, setsearchData] = useState({
        groupID: "0",
        estateID: "0",
        divisionID: "0",
        date: "",
        jobTypeID: ""
    });
    const [customSearch, setCustomSearch] = useState({
        regNumber: ''
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        estate: "",
        division: "",
        field: "",
        date: "",
        jobType: ""
    });
    const [summeryValues, setSummeryValues] = useState({
        totalLitres: 0,
        totallatex: 0,
        totalscrap: 0,
        totalotHours: 0
    });

    const [summeryValuesOne, setSummeryValuesOne] = useState({
        totalLitres: 0,
        totallatex: 0,
        totalscrap: 0,
        alltotal: 0,
        totalempCount: 0
    });
    const [errors, setErrors] = useState({});
    const schema = Joi.object(TappingCheckListReportSchema).options({ allowUnknown: true });

    const [data, setdata] = useState([]);
    const [data1, setdata1] = useState([]);
    const [summeryData, setSummeryData] = useState([]);
    const DropdownChanges = Object.freeze({ "group": 1, "operationEntity": 2 })
    const [searchButtonHide, setSearchButtonHide] = useState(false);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [estates, setEstates] = useState([])
    useEffect(() => {
        trackPromise(
            getPermissions(),
            getJobsForDropdown()
        )
    }, [])

    useEffect(() => {
        trackPromise(
            getEsatesForDropDown()
        )
        resetDropDowns(DropdownChanges.group);
    }, [searchData.groupID])

    useEffect(() => {
        if (searchData.estateID > 0) {
            trackPromise(
                getCollectionCategoryForDropDown()
            )
            resetDropDowns(DropdownChanges.estates);
        }
    }, [searchData.estateID])

    useEffect(() => {
        trackPromise(getDivisionsForDropDown());
    }, [searchData.estateID]);

    useEffect(() => {
        handleSearch1(customSearch.regNumber);
    }, [customSearch.regNumber]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        // var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWTAPPINGCHECKLISTREPORT');
        // if (isAuthorized === undefined) {
        //     props.history.push('/unauthorized');
        // }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            estateID: token.operationEntityID,
            divisionID: token.divisionID
        });

        getGroupsForDropDown();
    }

    function resetDropDowns(type) {
        if (type === DropdownChanges.estates) {
            setsearchData({
                ...searchData,
                collectionPointID: "0",
            });
        } else if (type === DropdownChanges.group) {
            setsearchData({
                ...searchData,
                estateID: "0",
                divisionID: "0",
            });
        }
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getEsatesForDropDown() {
        const factoryList = await divisionService.getEstatesByGroupID(searchData.groupID);
        setEstates(factoryList);
    }

    async function getCollectionCategoryForDropDown() {
        const collectionCategory = await service.getCollectionCategoryByOperationEntityForDropDown(searchData.estateID);
        setCollectionCategory(collectionCategory);
    }

    async function getDivisionsForDropDown() {
        const divisionList = await service.getDivisionsForDropDown(searchData.estateID);
        setDivision(divisionList);
    }

    async function getJobsForDropdown() {
        const result = await service.getJobsForDropdown();
        setJobs(result);
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;
        const error = { ...errors };
        const errorMessage = validateProperty(target, TappingCheckListReportSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        });

        setErrors(error);
        clearTableRelatedData();
    }

    async function handleSearch(e) {
        e.preventDefault();

        const errorMessages = validate(schema, searchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;
        let model = {
            divisionID: parseInt(searchData.divisionID),
            searchDate: searchData.date,
            jobTypeID: jobs[searchData.jobTypeID]
        }
        let result = await service.getReportData(model);
        formatResult(result);
        getSelectedDropdownValuesForReport(searchData);

    }

    function formatResult(data) {
        var result = [];
        data.forEach(x => {
            x.details.forEach(y => {

                var duplicateDate = result.find(z => z.employeeID === y.employeeID);

                if (duplicateDate) {
                    duplicateDate.employeeID = y.employeeID;
                    duplicateDate.registrationNumber = y.registrationNumber;
                    duplicateDate.firstName = y.firstName;
                    duplicateDate.fieldID = y.fieldID;
                    duplicateDate.fieldName = y.fieldName;
                    duplicateDate.otHours = y.otHours;
                    duplicateDate.taskCode = y.taskCode;
                    duplicateDate.collectionTypeCode = y.collectionTypeCode;
                    duplicateDate.totalLitres = duplicateDate.totalLitres + y.totalLitres;
                    duplicateDate.metrolacValue = duplicateDate.metrolacValue + y.metrolacValue;
                    duplicateDate.latex = y.collectionTypeCode == "163" || y.collectionTypeCode == "PC" ? duplicateDate.latex + y.dryRubberKilo : duplicateDate.latex + 0
                    duplicateDate.scrap = y.collectionTypeCode == "162" ? duplicateDate.scrap + y.dryRubberKilo : duplicateDate.scrap + 0
                }
                else {
                    result.push({
                        employeeID: y.employeeID,
                        registrationNumber: y.registrationNumber,
                        firstName: y.firstName,
                        fieldID: y.fieldID,
                        fieldName: y.fieldName,
                        otHours: y.otHours,
                        taskCode: y.taskCode,
                        totalLitres: y.totalLitres,
                        metrolacValue: y.metrolacValue,
                        collectionTypeCode: y.collectionTypeCode,
                        latex: y.collectionTypeCode == "163" || y.collectionTypeCode == "PC" ? y.dryRubberKilo : 0,
                        scrap: y.collectionTypeCode == "162" ? y.dryRubberKilo : 0
                    });
                }

            });
        });
        const totalLitres = result.reduce((accumulator, current) => accumulator + current.totalLitres, 0);
        const totallatex = result.reduce((accumulator, current) => accumulator + current.latex, 0);
        const totalscrap = result.reduce((accumulator, current) => accumulator + current.scrap, 0);
        const totalotHours = result.reduce((accumulator, current) => accumulator + current.otHours, 0);

        setSummeryValues({
            ...summeryValues,
            totalLitres: totalLitres,
            totallatex: totallatex,
            totalscrap: totalscrap,
            totalotHours: totalotHours
        });
        setdata(result)
        summeryTableCreation(result)
    }

    function summeryTableCreation(data) {

        var result = [];
        data.forEach(y => {

            var duplicateDate = result.find(z => z.fieldID === y.fieldID);

            if (duplicateDate) {
                duplicateDate.fieldID = y.fieldID;
                duplicateDate.fieldName = y.fieldName;
                duplicateDate.totalLitres = duplicateDate.totalLitres + y.totalLitres;
                duplicateDate.latex = duplicateDate.latex + y.latex;
                duplicateDate.scrap = duplicateDate.scrap + y.scrap;
                duplicateDate.empCount = duplicateDate.empCount + 1;
                duplicateDate.total = duplicateDate.total + (y.scrap + y.latex)
            }
            else {
                result.push({
                    fieldID: y.fieldID,
                    fieldName: y.fieldName,
                    totalLitres: y.totalLitres,
                    latex: y.latex,
                    scrap: y.scrap,
                    empCount: 1,
                    total: (y.scrap + y.latex)
                });
            }

        });

        var copyOfRecords = _.cloneDeep(result);

        for (let index = 0; index < 7; index++) {
            if (index == 0) {
                result[index].description = 'Tree Scrap.............................. Kgs. % Wet Wt. ..............................';
            }
            else if (index == 1) {
                if (result[index] == undefined) {
                    result.push({ description: 'Shell Scrap.............................. Kgs. % Wet Wt. ..............................' })
                }
                else {
                    result[index].description = 'Shell Scrap.............................. Kgs. % Wet Wt. ..............................';
                }
            }
            else if (index == 2) {
                if (result[index] == undefined) {
                    result.push({ description: 'Bark Scrap.............................. Kgs. % Wet Wt. ..............................' })
                }
                else {
                    result[index].description = 'Bark Scrap.............................. Kgs. % Wet Wt. ..............................';
                }
            }
            else if (index == 3) {
                if (result[index] == undefined) {
                    result.push({ description: 'Earth Scrap.............................. Kgs. % Wet Wt. ..............................' })
                }
                else {
                    result[index].description = 'Earth Scrap.............................. Kgs. % Wet Wt. ..............................';

                }
            }
            else if (index == 4) {
                if (result[index] == undefined) {
                    result.push({ description: 'Total Scrap Kgs...............................' })
                }
                else {
                    result[index].description = 'Total Scrap Kgs...............................';
                }

            }
            else if (index == 5) {
                if (result[index] == undefined) {
                    result.push({ description: 'Average Tapper Latex.............................. Kgs.' })
                }
                else {
                    result[index].description = 'Average Tapper Latex.............................. Kgs.';
                }
            }
            else if (index == 6) {
                if (result[index] == undefined) {
                    result.push({ description: 'Average Tapper Scrap.............................. Kgs.' })
                }
                else {
                    result[index].description = 'Average Tapper Scrap.............................. Kgs.';
                }
            }
            else if (index == 7) {
                if (result[index] == undefined) {
                    result.push({ description: 'Average Tapper Total.............................. Kgs.' })
                }
                else {
                    result[index].description = 'Average Tapper Total.............................. Kgs.';
                }
            }
        }
        const totalLitres = copyOfRecords.reduce((accumulator, current) => accumulator + current.totalLitres, 0);
        const totallatex = copyOfRecords.reduce((accumulator, current) => accumulator + current.latex, 0);
        const totalscrap = copyOfRecords.reduce((accumulator, current) => accumulator + current.scrap, 0);
        const alltotal = copyOfRecords.reduce((accumulator, current) => accumulator + current.total, 0);
        const totalempCount = copyOfRecords.reduce((accumulator, current) => accumulator + current.empCount, 0);

        setSummeryValuesOne({
            ...summeryValuesOne,
            totalLitres: totalLitres,
            totallatex: totallatex,
            totalscrap: totalscrap,
            alltotal: alltotal,
            totalempCount: totalempCount
        });
        setSummeryData(result)
    }

    function createPDF(data) {
        const originalArray = data
        const chunkSize = 4;
        const splitArrays = [];

        for (let i = 0; i < originalArray.length; i += chunkSize) {
            splitArrays.push(originalArray.slice(i, i + chunkSize));
        }
        splitArrays.forEach(x => {
            x.forEach((y, index) => {
                y.indexCount = index + 1
            })
        })
        if (splitArrays[splitArrays.length - 1] != 4) {
            for (let index = 0; index < 4 - splitArrays[splitArrays.length - 1]; index++) {
                splitArrays[(splitArrays.length - 1)].push({
                    fieldID: 0,
                    fieldName: '',
                    totalLitres: 0,
                    latex: 0,
                    scrap: 0,
                    empCount: 0,
                    total: 0
                });
            }
        }
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            division: division[searchForm.divisionID],
            date: searchForm.date,
            jobType: jobs[searchForm.jobTypeID]
        })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function onCancelClick() {
        setsearchData({
            ...searchData,
            divisionID: "0",
            date: ""
        });

        clearTableRelatedData();
    }

    function clearTableRelatedData() {
        setdata([]);
        setIsTableHide(true);
        setSelectedSearchValues([]);
    }

    async function handleSearch1(data2) {
        if (data == null || data.length == 0) {
            setdata(data1)
        }
        const Default = data.filter(x => x.registrationNumber.toLowerCase().includes(data2.toLowerCase()) || x.firstName.toLowerCase().includes(data2.toLowerCase()))
        if (data2 == '') {
            setdata(data1)
            return;
        }
        setdata(Default)
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <div className="row">
                            <PageHeader
                                title="Tapping Check List Report"
                                isButtonEnable={false}
                            />
                        </div>
                        <form>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="estateID">Estate *</InputLabel>
                                    <Select fullWidth
                                        id="estateID"
                                        name="estateID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        value={searchData.estateID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Estate--</MenuItem>
                                        {generateDropDownMenu(estates)}
                                    </Select>
                                    {errors["estateID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="divisionID">Division *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="divisionID"
                                        name="divisionID"
                                        value={searchData.divisionID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Division--</MenuItem>
                                        {generateDropDownMenu(division)}
                                    </Select>
                                    {errors["divisionID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="searchDate">Date *</InputLabel>
                                    <TextField
                                        fullWidth
                                        id="date"
                                        name="date"
                                        type="date"
                                        value={searchData.date}
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="jobTypeID">Job Type *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="jobTypeID"
                                        name="jobTypeID"
                                        value={searchData.jobTypeID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="">--Select Job type--</MenuItem>
                                        {generateDropDownMenu(jobs)}
                                    </Select>
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        disabled={validate(schema, searchData)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                        hidden={searchButtonHide}
                                    />
                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </div>
                        </form>
                        {data.length > 0 ?
                            <Card>
                                <div>
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="left" colSpan={2} style={{ fontWeight: "bold" }}>
                                                </TableCell>
                                                <TableCell align="left" colSpan={1} style={{ fontWeight: "bold", width: "250px" }}>
                                                    Initial of Field Officer
                                                </TableCell>
                                                <TableCell align="left" colSpan={3} style={{ fontWeight: "bold", width: "250px" }}>
                                                </TableCell>
                                                <TableCell align="left" colSpan={2} style={{ fontWeight: "bold" }}>
                                                    Norm / Task
                                                </TableCell>
                                                <TableCell align="left" colSpan={2} style={{ fontWeight: "bold" }}>
                                                </TableCell>
                                                <TableCell align="left" colSpan={2} style={{ fontWeight: "bold" }}>
                                                    Date
                                                </TableCell>
                                                <TableCell align="left" colSpan={2} style={{ fontWeight: "bold" }}>
                                                    {searchData.date}
                                                </TableCell>
                                            </TableRow>

                                            <TableRow>
                                                <TableCell colSpan={2}></TableCell>
                                                <TableCell colSpan={1} align="left" style={{ fontWeight: "bold" }}>
                                                    Estate
                                                </TableCell>
                                                <TableCell colSpan={3} align="left" style={{ fontWeight: "bold" }}>
                                                    {selectedSearchValues.estate}
                                                </TableCell>
                                                <TableCell align="left" colSpan={14} style={{ fontWeight: "bold" }}>
                                                    Name and Initial of Field Asst.
                                                </TableCell>

                                            </TableRow>
                                            <TableRow>
                                                <TableCell colSpan={2}></TableCell>
                                                <TableCell colSpan={1} align="left" style={{ fontWeight: "bold" }}>
                                                    Division
                                                </TableCell>
                                                <TableCell colSpan={3} align="left" style={{ fontWeight: "bold" }}>
                                                    {selectedSearchValues.division}
                                                </TableCell>
                                                <TableCell align="left" colSpan={4} style={{ fontWeight: "bold" }}>
                                                    No. of Workers at Muster : {data.length}
                                                </TableCell>
                                                <TableCell align="left" colSpan={4} style={{ fontWeight: "bold" }}>
                                                    Muster Distributed by :
                                                </TableCell>
                                            </TableRow>

                                            <TableRow>
                                                <TableCell colSpan={6}></TableCell>
                                                <TableCell align="left" colSpan={4} style={{ fontWeight: "bold" }}>
                                                    Field Officer :
                                                </TableCell>
                                                <TableCell align="left" colSpan={4} style={{ fontWeight: "bold" }}>
                                                    Supervisor :
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell></TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                    E.P.F No.
                                                </TableCell>
                                                <TableCell align="center" colSpan={1} style={{ fontWeight: "bold" }}>
                                                    Name
                                                </TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                    Normal OT.
                                                </TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                    Field No.
                                                </TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                    Block No.
                                                </TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                    No. of Litres
                                                </TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                    Metrolac Reading
                                                </TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                    Latex Kgs.
                                                </TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                    Scrap Kgs.
                                                </TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                    Over Kgs.
                                                </TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                    Day
                                                </TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                    OT Job Code
                                                </TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                    OT Hours
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>

                                            {data.map((row, index) => (
                                                <TableRow key={row.registrationNumber}>

                                                    <TableCell align="center">
                                                        {index + 1}
                                                    </TableCell>
                                                    <TableCell align="left" >
                                                        {row.registrationNumber}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        <Grid container >
                                                            <Grid item md={row.collectionTypeCode == "PC" ? 9 : 12} xs={12}>
                                                                {row.firstName}
                                                            </Grid>
                                                            {row.collectionTypeCode == "PC" ?
                                                                <Grid item md={3} xs={12}>
                                                                    <Box display="flex" flexDirection="row-reverse" >
                                                                        (PC)
                                                                    </Box>
                                                                </Grid> : null}
                                                        </Grid>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        -
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {row.fieldName}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        -
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        {row.totalLitres == 0 ? '-' : parseFloat(row.totalLitres).toFixed(2)}
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        {row.metrolacValue == 0 ? '-' : parseFloat(row.metrolacValue).toFixed(2)}
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        {row.latex == 0 ? '-' : parseFloat(row.latex).toFixed(2)}
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        {row.scrap == 0 ? '-' : parseFloat(row.scrap).toFixed(2)}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        -
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        -
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {row.taskCode == null ? '-' : row.taskCode}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {row.otHours == 0 ? '-' : parseFloat(row.otHours).toFixed(2)}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell></TableCell>
                                                <TableCell></TableCell>
                                                <TableCell colSpan={1} style={{ fontWeight: "bold" }} align="center">
                                                    Total
                                                </TableCell>
                                                <TableCell></TableCell>
                                                <TableCell></TableCell>
                                                <TableCell></TableCell>
                                                <TableCell align="right" style={{ fontWeight: "bold" }} >
                                                    {summeryValues.totalLitres == 0 ? '' : parseFloat(summeryValues.totalLitres).toFixed(2)}
                                                </TableCell>
                                                <TableCell></TableCell>
                                                <TableCell align="right" style={{ fontWeight: "bold" }} >
                                                    {summeryValues.totallatex == 0 ? '' : parseFloat(summeryValues.totallatex).toFixed(2)}
                                                </TableCell>
                                                <TableCell align="right" style={{ fontWeight: "bold" }} >
                                                    {summeryValues.totalscrap == 0 ? '' : parseFloat(summeryValues.totalscrap).toFixed(2)}
                                                </TableCell>
                                                <TableCell></TableCell>
                                                <TableCell></TableCell>
                                                <TableCell></TableCell>
                                                <TableCell align="right" style={{ fontWeight: "bold" }}>
                                                    {summeryValues.totalotHours == 0 ? '' : parseFloat(summeryValues.totalotHours).toFixed(2)}
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </div><br></br>

                                <Table size='small' aria-label="simple table2">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{ fontWeight: "bold" }} align="center">
                                                Field No
                                            </TableCell>
                                            <TableCell style={{ fontWeight: "bold" }} align="center">
                                                No. of Tappers
                                            </TableCell>
                                            <TableCell style={{ fontWeight: "bold" }} align="center">
                                                DT Blocks
                                            </TableCell>
                                            <TableCell style={{ fontWeight: "bold" }} align="center">
                                                Vacant Blocks
                                            </TableCell>
                                            <TableCell style={{ fontWeight: "bold" }} align="center">
                                                Latex Litres
                                            </TableCell>
                                            <TableCell style={{ fontWeight: "bold" }} align="center">
                                                Latex Kgs.
                                            </TableCell>
                                            <TableCell style={{ fontWeight: "bold" }} align="center">
                                                Scrap Kgs.
                                            </TableCell>
                                            <TableCell style={{ fontWeight: "bold" }} align="center">
                                                Total Kgs.
                                            </TableCell>
                                            <TableCell colSpan={7} style={{ fontWeight: "bold" }} align="center">
                                                Total Latex Kgs.
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {summeryData.map((row) => (
                                            <TableRow >
                                                <TableCell align="left" >
                                                    {row.fieldName == undefined ? '' : row.fieldName}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {row.empCount == undefined ? '' : parseInt(row.empCount)}
                                                </TableCell>
                                                <TableCell align="center">

                                                </TableCell>
                                                <TableCell align="center">

                                                </TableCell>
                                                <TableCell align="right">
                                                    {row.totalLitres == undefined ? '' : row.totalLitres == 0 ? '' : parseFloat(row.totalLitres).toFixed(2)}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {row.latex == undefined ? '' : row.latex == 0 ? '' : parseFloat(row.latex).toFixed(2)}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {row.scrap == undefined ? '' : row.scrap == 0 ? '' : parseFloat(row.scrap).toFixed(2)}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {row.total == undefined ? '' : row.total == 0 ? '' : parseFloat(row.total).toFixed(2)}
                                                </TableCell>
                                                <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                    {row.description == undefined ? '' : row.description}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell align="center" style={{ fontWeight: "bold" }} >
                                                Total
                                            </TableCell>
                                            <TableCell align="right" style={{ fontWeight: "bold" }} >
                                                {summeryValuesOne.totalempCount == 0 ? '' : parseInt(summeryValuesOne.totalempCount)}
                                            </TableCell>
                                            <TableCell></TableCell>
                                            <TableCell></TableCell>
                                            <TableCell align="right" style={{ fontWeight: "bold" }} >
                                                {summeryValuesOne.totalLitres == 0 ? '' : parseFloat(summeryValuesOne.totalLitres).toFixed(2)}
                                            </TableCell>
                                            <TableCell align="right" style={{ fontWeight: "bold" }} >
                                                {summeryValuesOne.totallatex == 0 ? '' : parseFloat(summeryValuesOne.totallatex).toFixed(2)}
                                            </TableCell>
                                            <TableCell align="right" style={{ fontWeight: "bold" }} >
                                                {summeryValuesOne.totalscrap == 0 ? '' : parseFloat(summeryValuesOne.totalscrap).toFixed(2)}
                                            </TableCell>
                                            <TableCell align="right" style={{ fontWeight: "bold" }} >
                                                {summeryValuesOne.alltotal == 0 ? '' : parseFloat(summeryValuesOne.alltotal).toFixed(2)}
                                            </TableCell>
                                            <TableCell></TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </Card>
                            : null}
                    </div>
                    {data.length != 0 ?
                        <div className="pt-2">
                            <ReactToPrint
                                documentTitle={"Tapping Checklist Report"}
                                trigger={() => <input
                                    type="button"
                                    className="btn btn-primary pull-right ml-2"
                                    value="PDF"
                                />}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePdf ref={componentRef} data={data} summeryValues={summeryValues} summeryData={summeryData}
                                    selectedSearchValues={selectedSearchValues} summeryValuesOne={summeryValuesOne} searchData={searchData}
                                />
                            </div>
                        </div>
                        : null}
                </div>
            </div>
        </Fragment >
    );
}



